<template>
    <div class="alumnusInfo clear">
        <div class="info_l page_l">
        </div>
        <div class="info_r page_r">
            <div class="main">
                <div class="content">
                    <div class="info_header">
                        <h1 class="title">同济校友邮箱</h1>
                        <p>请同济校友进行你的身份验证信息</p>
                    </div>
                    <div class="infoSection">
                        <info-form></info-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InfoForm from './infoForm'


export default {
    name: 'alumnusInfo',
    components: {
      InfoForm
    },
    data(){
        return{
        }
    }
    
}
</script>

<style scoped>
.alumnusInfo{
    width: 100%;
}
.info_l{
    background: url("../../../assets/img/bigBg/yz_bg.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.page_r .main .content{
    width: 350px;
    height: 460px;
    margin: 0 auto;
    position: relative;
    top: 50%;
    margin-top: -225px;
}

.home_titile h3{
    font-weight: 600;
    font-size:28px;
    color:#1c1c1c;
}

.info_header{
    width: 100%;
    font-weight: 600;
    text-align: center;
}
.info_header .title{
    font-size: 26px;
    color: #f25170;
}
.info_header p{
    font-size: 15px;
    color: #242c3f;
    
}

</style>



// WEBPACK FOOTER //
// src/page/officialEmail/checkIdentity/index.vue